module.exports = __webpack_public_path__ + "media/Tropic_Of_Cancer.084b0d07.png";


//////////////////
// WEBPACK FOOTER
// ./src/resources/images/labels/Tropic_Of_Cancer.png
// module id = 1119
// module chunks = 0